import React, { useEffect } from 'react'
import { PrimeIcons } from 'primereact/api';
import { useHistory } from 'react-router-dom';

import { TawreedActionName, TawreedAction } from '../../../../../common/actions';
import { TawreedTable, TawreedTableProps } from '../../../../../common/components/table';
import { Routes } from '../../../../../router';
import { OrderDto, orderService as service } from '../../domain';
import { TawreedTableFilters } from '../../../../../common/components/table/filters';
import { GlobalContext } from '../../../../../context';
import { TawreedTableFormatters } from "../../../../../common/components/table/formatters";
import { OrderStatus, ReportUrl } from "../../data";
import { PartnerType } from "../../../../partners/data";
import { CssUtils } from "../../../../../helpers/css";
import { DataTableSelectionModeType } from 'primereact/datatable';
import { TawreedTableDataSourceTrigger } from '../../../../../common/components/table/source';
import { Button } from 'primereact/button';
import { tawreedTranslationService } from '../../../../../common/translations';
import { Tag } from 'primereact/tag';
import { BulkActionDialog } from './bulk-actions-dialog';
import { OrderFormDialog } from './order-form-dialog';

export type OrdersTableProps = {
    /**
     * use returned orders context?
     */
    returned?: boolean;

    /**
     * status id
     */
    statusId?: OrderStatus;

    /**
     * partner type
     */
    partnerType?: PartnerType;
    partnerId?: number;

    /**
     * carrierId
     */
    carrierId?: number;

    /**
     * actions
     */
    actions?: Array<TawreedAction>;

    name: string;

    selectionMode?: DataTableSelectionModeType;
    selectionSelectAllOnLoad?: boolean;
    triggerMode?: TawreedTableDataSourceTrigger;

    pagination?: boolean;
    status?:number,
    title?: string
}
export type BulkActionsDialogState = {
    visible: boolean,
    orders: OrderDto[],
}
export type DetailDialogState = {
    visible: boolean,
    orderId: number | undefined,
}
export const OrdersTable: React.FC<OrdersTableProps> = ({ pagination, triggerMode, name, title, actions, returned, statusId, partnerId, partnerType, carrierId, selectionMode, selectionSelectAllOnLoad,status }) => {

    const { auth: { user }, constants: { constants } } = React.useContext(GlobalContext);

    const history = useHistory();
    const [reload, setReload] = React.useState(false);

    const [bulkDialogVisible, setBulDialogVisible] = React.useState<BulkActionsDialogState>({
        visible: false,
        orders: []
    });
    const [detailDialog, setDetailDialog] =React.useState<DetailDialogState>({
        visible: false,
        orderId: undefined
    });
    const [reportUrl, setReportUrl] = React.useState<ReportUrl| undefined>(undefined);

    const onForm = (sender?: OrderDto): Promise<void> => {
        return new Promise((resolve) => {
            const url = returned ? Routes.SalesOrdersReturnedDetails : Routes.SalesOrdersDetails;
            if (url && sender && sender.orderId) {
                history.push(url.replace(':id', sender.orderId.toString()))
            }
            resolve();
        });
    };
    const onPrint = (sender?: OrderDto | Array<OrderDto>) :Promise<void> => {
        return new Promise((resolve, reject) => {
            if (!sender) {
                reject('No item selected');

            } else if (Array.isArray(sender)) {

                return service.print(reportUrl!.pdfReportURI+"&order_ids="+sender.map(x=>x.orderId).join(","))
                .then(() => {
                })
                .catch(err => console.error(err));

                // return service.deleteAll(sender.map(e => e.storeProductQuantityLimitationId!)).then(() => setReload(true)).catch(err => console.error(err));
            } else {
                return service.print(reportUrl!.pdfReportURI+"&order_ids="+sender.orderId)
                .then(() => {
                })
                .catch(err => console.error(err));
                // return service.delete(sender.storeProductQuantityLimitationId!).then(() => setReload(true)).catch(err => console.error(err));
            }
            resolve();
        });
    };
    
    const showBulkModal = (sender?: OrderDto | Array<OrderDto>): Promise<void> => {
        return new Promise((resolve, reject) => {
            if (!sender) {
                reject('No item selected');

            } else if (Array.isArray(sender)) {
                setBulDialogVisible({
                    visible:true,
                    orders: sender
                });
                setReload(false);

                // return service.deleteAll(sender.map(e => e.storeProductQuantityLimitationId!)).then(() => setReload(true)).catch(err => console.error(err));
            } else {
                setBulDialogVisible({
                    visible:true,
                    orders: [sender]
                });
                setReload(false);
                // return service.delete(sender.storeProductQuantityLimitationId!).then(() => setReload(true)).catch(err => console.error(err));
            }
            resolve();
        });
    };
    useEffect(()=>{
        service.getSalesOrdersURL().then((res)=>{
            setReportUrl(res);
        });
    },[status])
    var bulk_actions = (status && (status === OrderStatus.Placed || status === OrderStatus.UNDER_REVIEWED))  ? [
        new TawreedAction(TawreedActionName.OrdersPrintStore, 'statefull', 'lbl_reports', PrimeIcons.PRINT, onPrint, "p-button-non-outlined flex-grow-1 md:flex-grow-0 mr-2", false),
        new TawreedAction(TawreedActionName.PartnerConnectionSetClassification, 'statefull', (e) => tawreedTranslationService.translate('lbl_bulk_action'), PrimeIcons.PLUS, showBulkModal, 'p-button-non-outlined flex-grow-1 md:flex-grow-0 mr-2', false),
    ]: [
        new TawreedAction(TawreedActionName.OrdersPrintStore, 'statefull', 'lbl_reports', PrimeIcons.PRINT, onPrint, "p-button-non-outlined flex-grow-1 md:flex-grow-0 mr-2", false)];

    const getStatusColumnDependOnPage = () => {
        const arr = [];
        if (!status)
            arr.push({
                dataType: 'text',
                field: "statusId",
                header: "lbl_sales_orders_status",
                sortable: true,
                filter: true,
                ...TawreedTableFilters.dropdown.dropdown("statusId", constants?.orderStatuses ?? [], 'value', 'label', 'in'),
                style: CssUtils.width('10%'),
            })
        return arr;
    }
    const getPartnerColumnDependOnPage = () => {
        const arr = [];
        if (user?.roleCode === 'CUSTOMER_ADMIN')
            arr.push({
                dataType: 'text',
                field: "store.partnerName",
                header: "lbl_sales_orders_store",
                sortable: true,
                sortField: 'store',
                filter: true,
                filterField: 'store',
                style: CssUtils.width('15%'),
            })
        else
        {
            arr.push({
                dataType: 'text',
                field: "customer.partnerName",
                header: "lbl_sales_orders_customer",
                sortable: true,
                sortField: 'customer',
                filter: true,
                filterField: 'customer',
                style: CssUtils.width('15%', CssUtils.color('var(--success-color)'))
            });
            arr.push({
                dataType: 'text',
                field: "customer.address.state",
                header: "lbl_sales_orders_customer_state",
                sortable: true,
                sortField: 'customerStateName',
                filter: true,
                filterField: 'customerStateName',
                
                style: CssUtils.width('10%'),
            });
        }
        
        return arr;
    }
    const getCarrierColumnDepnedOnPage = () => {
        const arr = [];
        if (user?.roleCode != 'STORE_DELIVERY' && status != OrderStatus.Placed)
            arr.push({
                dataType: 'text',
                field: "carrier.partnerName",
                header: "lbl_sales_orders_carrier",
                sortable: true,
                sortField: 'carrierName',
                filter: true,
                filterField: 'carrierName',

                style: CssUtils.width('15%'),
            });
        return arr;
    }


    const tawreed: TawreedTableProps = {
        header: true,
        pagination: pagination ?? true,
        dataKey: 'customer',
        name: title ?? name,
        reload: reload,
        title: returned ? 'lbl_sales_returned_orders' : (title ? title :'lbl_sales_orders'),
        ds: {
            trigger: triggerMode,
            mode: 'lazy',
            onSearch: (req) => service.search(req, returned),
        },
        columns: returned ?
            [
                {
                    dataType: 'text',
                    field: "statusId",
                    header: "lbl_sales_orders_status",
                    sortable: true,
                    filter: true,
                    ...TawreedTableFilters.dropdown.dropdown("statusId", constants?.orderStatuses ?? [], 'value', 'label', 'in'),
                    style: CssUtils.width('10%'),
                },
                {
                    dataType: 'numeric',
                    field: "orderId",
                    header: "lbl_sales_orders_return_id",
                    sortable: true,
                    filter: true,
                    style: CssUtils.width('15%'),
                },
                {
                    dataType: 'numeric',
                    field: "salesOrderId",
                    header: "lbl_sales_orders_order_id",
                    sortable: true,
                    filter: true,
                    style: CssUtils.width('15%'),
                },
                {
                    field: "orderDate",
                    header: "lbl_sales_orders_date",
                    sortable: true,
                    filter: true,
                    ...TawreedTableFilters.date.range("orderDate", 'datetime'),
                    style: CssUtils.width('15%'),
                },  
                {
                    dataType: 'text',
                    field: "customer.partnerName",
                    header: "lbl_sales_orders_customer",
                    sortable: true,
                    sortField: 'customer',
                    filter: true,
                    filterField: 'customer',
                    style: CssUtils.width('20%'),
                },
                {
                    dataType: 'text',
                    field: "store.partnerName",
                    header: "lbl_sales_orders_store",
                    sortable: true,
                    sortField: 'store',
                    filter: true,
                    filterField: 'store',
                    style: CssUtils.width('20%'),
                },
                {
                    field: "orderTotal",
                    header: "lbl_sales_orders_order_total",
                    sortable: true,
                    filter: true,
                    ...TawreedTableFormatters.decimal('orderTotal', user?.scale!, CssUtils.width('15%')),
                    className: CssUtils.className.field.amount,
                },{
                    field: "actions",
                    body:(Options :any) => {
                        return <React.Fragment>
                            <Button
                             type='button'
                             style={{height:"35px"}}
                             icon={PrimeIcons.EYE}
                             className='p-button-success p-button-text'
                             tooltip={tawreedTranslationService.translate('lbl_info')}
                             onClick={()=>{
                                onForm(Options);
                             }}
                            />
                        </React.Fragment>
                    },
                    style:CssUtils.width('10%')
            }
            ]
            :
            [
                ...getStatusColumnDependOnPage(),
                {
                    dataType: 'numeric',
                    field: "orderId",
                    header: "lbl_sales_orders_header_order_id",
                    sortable: true,
                    filter: true,
                    style: CssUtils.width('15%', CssUtils.color('var(--danger-color)')),
                },
                {
                    field: "orderDate",
                    header: "lbl_sales_orders_header_date",
                    sortable: true,
                    filter: true,
                    ...TawreedTableFilters.date.range("orderDate", 'datetime'),
                    style: CssUtils.width('15%'),
                },
                {                    
                    field: "lastStatusUpdate",
                    header: "lbl_sales_orders_header_last_update",
                    style: CssUtils.width('10%'),
                  
                },
                // {
                //     dataType: 'text',
                //     field: "customer.partnerName",
                //     header: "lbl_sales_orders_customer",
                //     sortable: true,
                //     sortField: 'customer',
                //     filter: true,
                //     filterField: 'customer',
                //     style: CssUtils.width('15%', CssUtils.color('var(--success-color)')),
                // },
                // {
                //     dataType: 'text',
                //     field: "customer.address.state",
                //     header: "lbl_sales_orders_customer_state",
                //     sortable: true,
                //     sortField: 'customerStateName',
                //     filter: true,
                //     filterField: 'customerStateName',
                    
                //     style: CssUtils.width('10%'),
                // },
                ...getPartnerColumnDependOnPage(),
                ...getCarrierColumnDepnedOnPage(),
                {
                    dataType: 'text',
                    field: "priceListItem.name",
                    header: "lbl_sales_orders_header_pricelistid",
                    sortable: true,
                    sortField: 'priceListName',
                    filter: true,
                    filterField: 'priceListName',
                    style: CssUtils.width('15%'),
                }, {
                    dataType: 'text',
                    field: "paymentModeName",
                    header: "lbl_sales_orders_paymentmodeid",
                    sortable: true,
                    sortField: 'paymentModeName',
                    filter: true,
                    filterField: 'paymentModeName',
                    style: CssUtils.width('5%'),
                },
                {                    
                    field: "orderTotal",
                    header: "lbl_sales_orders_header_order_total",
                    sortable: true,
                    filter: true,
                    ...TawreedTableFormatters.decimal('orderTotal', user?.scale!, CssUtils.width('10%')),
                    className: CssUtils.className.field.amount,
                },
                {
                    field: "actions",
                    body:(Options :any) => {
                        return <React.Fragment>
                            <Button
                             type='button'
                             style={{height:"35px"}}
                             icon={PrimeIcons.EYE}
                             className='p-button-success p-button-text'
                             tooltip={tawreedTranslationService.translate('lbl_info')}
                             onClick={()=>{
                                onForm(Options);
                             }}
                            />
                        </React.Fragment>
                    },
                    style:CssUtils.width('10%')
            }
            ],
        toolbar: {
            actions: actions ?? [...bulk_actions],
        },
        
        filter: {
            filterDisplay: 'menu',
            initial: {
                carrierId: {
                    operator: 'AND',
                    constraints: [
                        {
                            value: carrierId,
                            matchMode: 'equals',
                        }
                    ]
                },
                priceListName:{
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'equals',
                        }
                    ]
                },
                customerId: {
                    operator: 'AND',
                    constraints: [
                        {
                            value: partnerType && partnerType === PartnerType.Store ? partnerId : undefined,
                            matchMode: 'equals',
                        }
                    ]
                },
                customerStateName: {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'equals',
                        }
                    ]
                },
                carrierName: {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'equals',
                        }
                    ]
                },
                statusId: {
                    operator: 'AND',
                    constraints: [
                        status ? { value: [status], matchMode: 'in' }: (statusId ? { value: [statusId], matchMode: 'in' } : { value: null, matchMode: 'in' }),
                    ]
                },
                orderId: {
                    operator: 'AND',
                    constraints: [
                        { value: null, matchMode: 'equals' },
                    ]
                },
                orderDate: {
                    operator: 'AND',
                    constraints: [
                        { value: null, matchMode: 'dateIs' }
                    ]
                },
                customer: {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'contains',
                        }
                    ]
                },
                store: {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'contains',
                        }
                    ]
                },
                orderTotal: {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'equals',
                        },
                    ]
                },
                paymentModeName: {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'equals',
                        },
                    ]   
                }
            },
        },
        sort: {
            sortMode: 'single',
            initial: {
                sortField: 'orderId',
                sortOrder: -1,
                multiSortMeta: undefined,
            },
        },
        selection: {
            mode: selectionMode ?? 'checkbox',
            selectAllOnLoad: selectionSelectAllOnLoad ?? undefined,
        },
    }

    return (
        <React.Fragment>
            <TawreedTable  {...tawreed} />
            <OrderFormDialog
                hide={() => {
                    service.getDetails(detailDialog.orderId!, returned)
                        .then(res => {
                            var neworders = [...bulkDialogVisible.orders];
                            var index = neworders.findIndex(x=>x.orderId === detailDialog.orderId);
                            neworders[index] = res;
                            setBulDialogVisible({
                                ...bulkDialogVisible, orders:neworders});
                        })
                        .catch(() => {
                        });

                    setDetailDialog({
                        orderId: undefined,
                        visible: false
                    });
                }}
                orderId={detailDialog.orderId!}
                visible={detailDialog.visible} />
            <BulkActionDialog
                status={status}
                orders={bulkDialogVisible.orders}
                visible={bulkDialogVisible.visible}
                onDetails={(id: number) => {
                    setDetailDialog({
                        orderId: id,
                        visible: true
                    })
                }}
                onRemove={(id:number)=>{
                    var neworders = [...bulkDialogVisible.orders];
                            var index = neworders.findIndex(x=>x.orderId === detailDialog.orderId);
                            neworders = neworders.splice(index,1);
                            setBulDialogVisible({
                                ...bulkDialogVisible, orders:neworders});
                }}
                hide={() => {
                    setBulDialogVisible({ ...bulkDialogVisible, visible: false });
                    setDetailDialog({
                        orderId: undefined,
                        visible: false
                    })
                    setReload(true);
                }} />
        </React.Fragment>);
}
